<template>
  <section id="pricing" class="pricing-section">
    <div class="container">
      <p class="pre-label">شفافية كاملة</p>
      <h2 class="section-title">
        أسعارنا تبدأ من <span class="gold-num">6,000</span> جنيه حتى فوق!
      </h2>
      <div class="gold-divider" />
      <p class="section-subtitle">
        نقدّم حلول برمجية احترافية تناسب جميع احتياجاتك
      </p>

      <div class="pricing-grid">
        <div
          v-for="(plan, i) in plans"
          :key="plan.name"
          class="plan-card"
          :class="{ featured: plan.featured }"
          :style="{ '--delay': i * 0.08 + 's' }"
        >
          <!-- Featured badge -->
          <div v-if="plan.featured" class="featured-badge">الأكثر طلباً</div>

          <!-- Header -->
          <div class="plan-header" :style="{ '--accent': plan.color }">
            <div class="plan-icon">{{ plan.icon }}</div>
            <h3 class="plan-name">{{ plan.name }}</h3>
            <p class="plan-target">{{ plan.target }}</p>
          </div>

          <!-- Price -->
          <div class="plan-price">
            <span class="price-label">ابتداءً من</span>
            <span class="price-amount" :style="{ color: plan.color }">
              {{ plan.price }}
            </span>
            <span class="price-unit">جنيه</span>
          </div>

          <!-- Features -->
          <ul class="plan-features">
            <li v-for="f in plan.features" :key="f">
              <span class="feat-check" :style="{ color: plan.color }">✓</span>
              {{ f }}
            </li>
          </ul>

          <!-- CTA -->
          <a
            :href="
              'https://wa.me/201234567890?text=أريد الاستفسار عن ' + plan.name
            "
            target="_blank"
            class="plan-btn"
            :style="plan.featured ? {} : { '--btn-color': plan.color }"
            :class="{ 'btn-featured': plan.featured }"
          >
            احجز الآن
          </a>
        </div>
      </div>

      <!-- Guarantees bar -->
      <div class="guarantees">
        <div v-for="g in guarantees" :key="g.label" class="guarantee-item">
          <span class="g-icon">{{ g.icon }}</span>
          <div>
            <strong>{{ g.label }}</strong>
            <span>{{ g.desc }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const plans = [
  {
    icon: "🚀",
    name: "الباقة الأساسية",
    target: "للمشاريع البسيطة",
    price: "6,000",
    color: "#22c55e",
    features: [
      "تصميم بسيط واحترافي",
      "تطبيق موبايل (شاشة محدودة)",
      "لوحة تحكم أساسية",
      "دعم فني لمدة 15 يوم",
    ],
  },
  {
    icon: "💼",
    name: "الباقة الاحترافية",
    target: "للمشاريع المتوسطة",
    price: "12,000",
    color: "#3b82f6",
    features: [
      "تصميم احترافي متكامل",
      "تطبيق موبايل كامل",
      "لوحة تحكم متقدمة",
      "ربط بقاعدة بيانات",
      "دعم فني لمدة شهر",
    ],
  },
  {
    icon: "📊",
    name: "الباقة المتقدمة",
    target: "للمشاريع الكبيرة",
    price: "20,000",
    color: "#8b5cf6",
    featured: true,
    features: [
      "تصميم احترافي فريد",
      "تطبيق موبايل كامل",
      "لوحة تحكم شاملة",
      "ربط APIs خارجية",
      "إشعارات فورية",
      "دعم فني لمدة شهرين",
    ],
  },
  {
    icon: "🏢",
    name: "باقة الشركات",
    target: "حلول متكاملة للشركات",
    price: "35,000",
    color: "#f97316",
    features: [
      "تصميم هوية بصرية",
      "تطبيق موبايل + ويب",
      "لوحة تحكم متكاملة",
      "تقارير وإحصاءات",
      "ربط بأنظمة الدفع",
      "دعم فني 3 أشهر",
    ],
  },
  {
    icon: "💎",
    name: "الباقة المميزة",
    target: "لمشاريع ضخمة",
    price: "60,000",
    color: "#ec4899",
    features: [
      "كل ما في الباقات السابقة",
      "خصائص مخصصة",
      "تكامل مع أنظمة أخرى",
      "أداء عالٍ وأمان متقدم",
      "دعم فني 6 أشهر",
    ],
  },
  {
    icon: "👑",
    name: "باقة مخصصة",
    target: "فوق التوقعات",
    price: "60,000+",
    color: "#D4AF37",
    features: [
      "حلول مخصصة بالكامل",
      "تقنيات متقدمة وحديثة",
      "تطوير حسب الطلب",
      "فريق عمل كامل",
      "دعم فني مستمر",
    ],
  },
];

const guarantees = [
  { icon: "🛡️", label: "جودة عالية", desc: "نضمن أفضل جودة في التنفيذ" },
  {
    icon: "⏰",
    label: "التزام بالمواعيد",
    desc: "نلتزم بتسليم مشروعك في الوقت المحدد",
  },
  { icon: "🎧", label: "دعم فني", desc: "دعم مستمر بعد تسليم المشروع" },
  { icon: "🤝", label: "أسعار تنافسية", desc: "أفضل الأسعار مقابل أفضل جودة" },
];
</script>

<style scoped>
.pricing-section {
  padding: 7rem 6vw;
  background: var(--bg-navy);
  position: relative;
}

.pricing-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
}

.pre-label {
  text-align: center;
  color: var(--gold);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.gold-num {
  color: var(--gold-light);
  background: none;
  -webkit-text-fill-color: var(--gold-light);
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
  align-items: stretch;
}

.plan-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 1.8rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  position: relative;
  transition: all 0.35s ease;
  animation: fadeInUp 0.6s var(--delay, 0s) ease both;
}

.plan-card:hover {
  transform: translateY(-5px);
  border-color: rgba(212, 175, 55, 0.4);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
}

.plan-card.featured {
  border-color: var(--gold);
  box-shadow: 0 0 0 1px var(--gold), 0 20px 60px rgba(212, 175, 55, 0.2);
  transform: translateY(-8px);
}

.featured-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, var(--gold), var(--gold-dark));
  color: #000;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 1rem;
  border-radius: 50px;
  white-space: nowrap;
}

.plan-header {
  text-align: center;
}

.plan-icon {
  font-size: 2.2rem;
  margin-bottom: 0.6rem;
  display: block;
}

.plan-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--white);
  margin-bottom: 0.3rem;
}

.plan-target {
  font-size: 0.8rem;
  color: var(--gray);
}

.plan-price {
  text-align: center;
  border-top: 1px solid var(--border);
  padding-top: 1rem;
}

.price-label {
  display: block;
  font-size: 0.78rem;
  color: var(--gray);
  margin-bottom: 0.3rem;
}

.price-amount {
  font-size: 2rem;
  font-weight: 900;
  display: block;
  font-family: "Montserrat", sans-serif;
}

.price-unit {
  font-size: 0.85rem;
  color: var(--gray);
}

.plan-features {
  list-style: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.plan-features li {
  font-size: 0.85rem;
  color: rgba(245, 245, 240, 0.8);
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.feat-check {
  font-weight: 700;
  flex-shrink: 0;
}

.plan-btn {
  display: block;
  text-align: center;
  padding: 0.7rem;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.9rem;
  border: 2px solid var(--btn-color, #d4af37);
  color: var(--btn-color, #d4af37);
  transition: all 0.3s;
}

.plan-btn:hover {
  background: var(--btn-color, #d4af37);
  color: #000;
}

.plan-btn.btn-featured {
  background: linear-gradient(135deg, var(--gold), var(--gold-dark));
  color: #000;
  border-color: transparent;
  box-shadow: 0 6px 24px var(--gold-glow);
}

.plan-btn.btn-featured:hover {
  transform: scale(1.03);
  box-shadow: 0 10px 30px rgba(212, 175, 55, 0.5);
}

/* Guarantees */
.guarantees {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 4rem;
  background: rgba(13, 31, 60, 0.6);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 2rem;
}

.guarantee-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 200px;
}

.g-icon {
  font-size: 2rem;
}

.guarantee-item div {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.guarantee-item strong {
  font-size: 0.95rem;
  color: var(--gold-light);
}

.guarantee-item span {
  font-size: 0.8rem;
  color: var(--gray);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 900px) {
  .pricing-section {
    padding: 5rem 1.5rem;
  }
  .pricing-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .plan-card.featured {
    transform: none;
  }
}

@media (max-width: 600px) {
  .pricing-grid {
    grid-template-columns: 1fr;
  }
}
</style>
